import * as angular from 'angular';
import * as _ from 'lodash';
import {Plant} from "../../models/navigation";
import {apsViewModels} from "../../shared/dto/APS.ViewModels";
import {apsCommands} from "../../shared/dto/aps.commands";
import UIUtilityServiceName, {EnumOption, UIUtilityService} from "../../services/utility/uiUtility.service";
import LoaderServiceName, {LoaderService} from "../../components/loader/loader.service";
import NotifyServiceName, {NotifyService} from "../../services/notify/notify.service";
import LineConfigsServiceName, {LineConfigsService} from "../../services/lineConfigs/lineConfigs.service";
import NewGuidServiceName, {NewGuidService} from "../../services/utility/newguid.service";
import {apsEnums} from "../../shared/dto/aps.enums";
import PalletizerServiceName, {PalletizerService} from "../../services/palletizers/palletizer.service";
import template from './editPalletizer.tpl.html';

let requires = [UIUtilityServiceName, LoaderServiceName, NotifyServiceName, LineConfigsServiceName, NewGuidServiceName,
  PalletizerServiceName];

export interface EditPalletizerParams {
  plant: Plant;
  palletizer: apsViewModels.PalletizerItem;
  plcs: apsViewModels.EquipmentDetail[];
}

export function openEditPalletizer(data: EditPalletizerParams,
                                   $modal: mm.foundation.modal): angular.IPromise<apsCommands.PalletizerBase> {
  return $modal.open({
    template: template,
    controller: 'EditPalletizerCtrl as vm',
    resolve: {
      data: function() {
        return data;
      }
    }
  }).result;
}

interface EditPalletizer {
  shops: apsViewModels.ShopNavigation[];
  palletizer: apsCommands.PalletizerBase;
  plcs: apsViewModels.EquipmentDetail[];
  dataPoints: apsViewModels.DataPointDetail[];
  lines: apsViewModels.LineItem[];
  form: angular.IFormController;
  isNew: boolean;
  signalTypes: EnumOption[];

  plcChanged(): void;
  shopChanged(): void;
  save(): void;
  cancel(): void;
}

export default angular.module('aps.controller.editPalletizer', requires)
  .controller('EditPalletizerCtrl', editPalletizer)
  .name;

function editPalletizer(loaderService: LoaderService,
                        palletizerService: PalletizerService,
                        notifyService: NotifyService,
                        lineConfigsService: LineConfigsService,
                        newGuidService: NewGuidService,
                        uiUtilityService: UIUtilityService,
                        data: EditPalletizerParams,
                        $modalInstance: mm.foundation.modalInstance): EditPalletizer {
  let vm = {} as EditPalletizer;

  vm.shops = data.plant.shops;
  vm.plcs = data.plcs;
  vm.lines = [];
  vm.signalTypes = uiUtilityService.getListOptionsFromEnum(apsEnums.PalletizerSignalType, 1);

  let initializeLineId = false;
  vm.isNew = false;

  vm.shopChanged = shopChanged;
  vm.plcChanged = plcChanged;
  vm.save = save;
  vm.cancel = cancel;

  if (data.palletizer) {
    vm.palletizer = {
      id: data.palletizer.id,
      plantId: data.plant.id,
      name: data.palletizer.name,
      lineId: null,
      shopId: data.palletizer.shopId,
      equipmentId: data.palletizer.equipmentId,
      dataPointId: data.palletizer.dataPointId,
      signalType: data.palletizer.signalType
    };

    setDataPoints();

    if (vm.palletizer.shopId) {
      initializeLineId = true;
      vm.shopChanged();
    }
  } else {
    vm.isNew = true;
    vm.palletizer = {
      id: null,
      plantId: data.plant.id,
      name: null,
      lineId: null,
      shopId: null,
      equipmentId: null,
      dataPointId: null,
      signalType: null
    };
    newGuidService.getNewGuid('palletizer').then(id => vm.palletizer.id = id);
  }

  return vm;

  function setDataPoints(): void {
    vm.dataPoints = null;
    if (!vm.palletizer.equipmentId) {
      return;
    }

    let plc = _.find(vm.plcs, {id: vm.palletizer.equipmentId});
    if (!plc) {
      return;
    }
    vm.dataPoints = plc.dataPoints;
  }

  function shopChanged(): void {
    vm.lines = [];
    vm.palletizer.lineId = null;
    if (!vm.palletizer.shopId) {
      return;
    }

    lineConfigsService.getLineConfiguration(vm.palletizer.shopId)
      .then(lineConfig => {
        vm.lines = lineConfig.lines.filter(l => !l.endJunctionId);
        if (!initializeLineId) {
          return;
        }
        let line = vm.lines.filter(l => _.some(l.equipment,
          e => e.type === apsEnums.LineEquipmentType.Palletizer));
        if (line.length > 0) {
          vm.palletizer.lineId = line[0].id;
        }
        initializeLineId = false;
      });
  }

  function plcChanged(): void {
    vm.palletizer.dataPointId = null;
    setDataPoints();
  }

  function save(): void {
    if (vm.form.$invalid) {
      return;
    }

    let saveFunc = vm.isNew ? palletizerService.add : palletizerService.update;
    loaderService.loadingPromise(saveFunc(vm.palletizer)
      .then(() => $modalInstance.close(vm.palletizer),
        notifyService.handleApiErrors));
  }

  function cancel(): void {
    $modalInstance.close();
  }
}


// WEBPACK FOOTER //
// ./src/app/controllers/palletizers/editPalletizer.controller.ts